import object from '@mailobj-browser/front/js/utils/object.js'
import file from '../fs/file.js'
import path from '../path/resolve.js'
import defer from '../network/defer.js'
import attach from '../actions/attach.js'

const intentName = 'android.intent.action.SEND'
export default object(null, {
  action: intentName,
  task: async (intent) => {
    console.log(`Managing ${intentName}`)
	
	const { clipItems, extras } = intent
    /* get input */
    if (!extras) {
	  const [item] = clipItems
      const itemPath = await path(item.uri)
      const itemFile = await file(itemPath)
      defer(() => attach([itemFile]))
    } else {

    }

  }
})
